import React from 'react'
import { 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem, 
    Grid, 
    TextField, 
    makeStyles,
    Button,
  } from '@material-ui/core';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch } from 'react-redux';
import { useForm } from '../../../../../hooks/useForm';
import { medicosAbmStoreOrUpdate } from '../../../../../actions/medicosabm/medicosAbm';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";


const useStyles = makeStyles ((theme)=> ({
    root: {
      backgroundColor: theme.palette.background.paper,
      marginTop: '30px',
      borderRadius: '5px',
      padding: '20px',
    },
    formControl: {
      marginTop: theme.spacing(2),
    },
    hideButton: {
      display: "none",
    },
    botonera: {
      padding: 25
  }
  }))

export const MedicosAbm = (props) => {

 const classes = useStyles()
 const dispatch = useDispatch()

  const formMedico = { 
    cuit: "",
    razonSoci: "",
    nombreEfector: "",
    idTipoEfector: 1,
    idSubTipoEfector: 7,
    telefonoContacto: "",
    mailContacto: "",
    idEstadoEfector: 1,
    fechaBaja: ""
  }

  const [
    formValues,
    handleInputChange,
    ,
    setearValor
  ] = useForm(props.Medicos ? props.Medicos : formMedico);

  const modificarFecha = props.idPanel === "idTabModi";

  const tipoPrestadorSelect = [
    'Profesionales de centros médicos propios',
  ] 

  const handleSave = (e) => {
    e.preventDefault()
    if(formValues.cuit === ""){
      formValues.cuit = 0
    }
    dispatch(medicosAbmStoreOrUpdate(formValues))
    props.cerrarModal();
    
}; 

  return (
      <ValidatorForm onSubmit={handleSave}>
          <Grid container spacing={2} style={{ padding: 25 }}>
          <Grid item xs={12} md={6}>
              <FormControl
                className={classes.formControl}
                margin="normal"
                fullWidth={true}
              >
                <InputLabel id="demo-simple-select-label">Tipo de Prestador</InputLabel>
                <Select
                  autoWidth
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={tipoPrestadorSelect}
                >
                  {tipoPrestadorSelect.map((name) => (
                    <MenuItem key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextValidator
                margin="normal"
                fullWidth={true}
                label="CUIT"
                name="cuit"
                validators={[
                  "required",
                  "isNumber",
                  "maxNumber:99999999999",
                  "minNumber:9999999999",
                ]}
                errorMessages={[
                  "El CUIT es requerido",
                  "Sólo números",
                  "Verifique CUIT ingresado",
                  "Verifique CUIT ingresado",
                ]}
                value={formValues.cuit}
                onChange={handleInputChange}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                margin="normal"
                fullWidth={true}
                label="Razón Social"
                name="razonSoci"
                value={formValues.razonSoci}
                autoComplete="off"
                onChange={(e)=>setearValor("razonSoci", e.target.value.toUpperCase())}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                margin="normal"
                fullWidth={true}
                label="Nombre (Fantasia)"
                name="nombreEfector"
                value={formValues.nombreEfector}
                autoComplete="off"
                onChange={(e)=>setearValor("nombreEfector", e.target.value.toUpperCase())}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextValidator
                margin="normal"
                fullWidth={true}
                id="standard-disabled"
                label="Email"
                name="mailContacto"
                value={formValues.mailContacto}
                autoComplete="off"
                onChange={handleInputChange}
                validators={[
                  "required", 
                  "isEmail"
                ]}
                errorMessages={[
                  "El Email es requerido", 
                  "Email invalido"
                ]}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextValidator
                margin="normal"
                fullWidth={true}
                id="standard-disabled"
                label="Teléfono(sin 0)"
                name="telefonoContacto"
                value={formValues.telefonoContacto || ""}
                onChange={handleInputChange}
                autoComplete="off"
                validators={[
                  "required",
                  "isNumber",
                  "maxNumber:9999999999",
                  "minNumber:999999999",
                ]}
                errorMessages={[
                  "El teléfono es requerido",
                  "Sólo números",
                  "Verifique su teléfono",
                  "Verifique su teléfono",
                ]}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MuiPickersUtilsProvider
                locale={esLocale} 
                utils={DateFnsUtils}
              >
                <KeyboardDatePicker
                  disableToolbar
                  fullWidth={true}
                  margin="normal"                  
                  id="fechaBaja"
                  label="Fecha Baja"
                  variant="inline"
                  format="dd/MM/yyyy"
                  disabled={ modificarFecha ? false : true }
                  maxDate={moment(new Date()).add(3,'M')}
                  value={
                    moment(formValues.fechaBaja).isValid()
                      ? moment(formValues.fechaBaja)
                      : null
                  }
                  onChange={(date) => {
                    setearValor("fechaBaja", date);
                  }}
                  KeyboardButtonProps={{
                      'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} md={6}>
                   
            </Grid>
            <Grid container className={classes.botonera} >
             <Grid item xs={12}>
                <Grid
                                container
                                spacing={1}
                                direction="row"
                                justify="flex-end"
                                alignItems="center"
                            >
                                    <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    startIcon={<CancelIcon />}
                                    onClick={props.cerrarModal}
                                >
                                    CANCELAR
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<SaveIcon />}
                                    type='submit'
                                    style={{ marginLeft: "0.5rem" }}
                                >
                                    GUARDAR
                                </Button>
                            </Grid>
             </Grid>
            </Grid>
            </Grid> 
      </ValidatorForm>
  )
}
